import { Component, Input, OnInit } from '@angular/core';
import { RecommendedService } from '../../../api/recommendedService/recommendedService';
import { orderBy } from 'src/app/utils/collection-utils';
import { RecommendedServiceApiService } from 'src/app/api/recommendedService/recommendedServiceApiService';

@Component({
    selector: 'asset-service-recommendations',
    templateUrl: './asset-service-recommendations.component.html',
    styleUrls: ['./asset-service-recommendations.component.css'],
    host: {'class': 'service-recommendations'},
    standalone: false
})
export class AssetServiceRecommendationsComponent implements OnInit {
  @Input() assetId: string | undefined = undefined;
  recommendedServices: RecommendedService[] = [];
  loading: boolean = false;

  displayedColumns: string[] = [
    'id',
    'sourceSystemId',
    'status',
    'plannedDate',
    'typeDescription',
    'controls'
  ];

  constructor(private recommendedServiceApiService: RecommendedServiceApiService) { }

  ngOnInit(): void {
    if (this.assetId == undefined) {
      console.log("Empty asset, cannot load recommended services");
      return;
    }

    this.loading = true;
    this.recommendedServiceApiService.getRecommendedServicesForAsset(this.assetId)
      .subscribe(x => {
        this.recommendedServices = orderBy(x, y => y.plannedDate);
        this.loading = false;
      });
  }
}
